import React from 'react';

import Post from '../components/Post';

export default class PostController extends React.Component {
  constructor(props) {
    super(props);
    this.state = {loading: true};
  }

  componentWillMount() {
    const that = this;
    fetch('/api/post/' + this.props.match.params.id, {credentials: 'same-origin', method: 'GET'})
      .then((res) => {
        res.json().then((post) => {
          that.setState({post, loading: false});
        });
      });
  }

  render() {
    if (this.state.loading) {
      return <div>Loading post...</div>;
    }
    return (<div className='container'>
        <div className='row'>
          <div className='col-md-6 col-md-offset-3'>
            <Post content={this.state.post.content} day={this.state.post.day} title={this.state.post.title} />
          </div>
        </div>
    </div>);
  }
}



// WEBPACK FOOTER //
// ./src/controllers/PostController.js